<template>
    <zk-admin-table title="受种者管理" :loading="loading" :table="table" @change="handleTableChange">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button size="mini" icon="el-icon-search" circle @click="searchVisible=!searchVisible"></el-button>
                <el-button size="mini" icon="el-icon-refresh" circle @click="getData"></el-button>
            </el-row>
        </template>
        <template v-slot:search>
            <search-form @search="handleSearch" v-show="searchVisible" :search="search" />
        </template>
        <el-table-column type="index" label="序号" fixed="left" :index="(index) => {return (this.table.page - 1) * this.table.pageSize+ index + 1}" width="100">
        </el-table-column>
        <el-table-column align="left" v-for="(v, idx) in table.columns" :prop="v.field" :label="v.title"
            :width="v.width" :formatter="v.formatter" :key="idx">
        </el-table-column>
    </zk-admin-table>
</template>

<script>
import SearchForm from './widgets/searchForm'
import data from './data'

export default {
    name: 'main-patient',
    path: '/main/patient',
    components: {
        SearchForm
    },
    data() {
        const current = new Date()
        const today = current.format('yyyy-MM-dd')
        return {
            loading: false,
            table: data.table,
            searchVisible: true,
            search: {
                date: today
            }
        }
    },
    methods: {
        dialogClose() {
            this.dialogVisible = false
            this.getData()
        },
        handleSearch(e) {
            this.search = e
            this.table.page = 1
            this.getData()
        },
        handleTableChange(e) {
            this.table = e
            this.getData()
        },
        async getData() {
            this.loading = true
            try {
                const resp = await this.$http.get(`/patient?page=${this.table.page}&pageSize=${this.table.pageSize}`, { params: this.search })
                if (!resp.data) {
                    this.$message.error(resp.data.msg)
                } else {
                    this.table.data = resp.data.data.records
                    this.table.total = resp.data.data.total
                }
            } catch (e) {
                this.$message.error(e.message)
            }
            this.loading = false
        }
    },
    mounted() {
        this.getData()
    }
}
</script>
